import React, { useState } from "react";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {
  Button,
  Chip,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography,
  useTheme,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DetailsTwoToneIcon from "@material-ui/icons/DetailsTwoTone";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import styles from "../../styles/global-styles";
import SearchIcon from "@material-ui/icons/Search";
import { SellService } from "../../services/sell.service";
import { connect } from "react-redux";
import { actions as actionsAlert } from "../../redux/actions/alert";
import StyledTableCell from "../../styles/tableCell";
import NumberFormat from "react-number-format";
import TableHeadSells from "../../components/stateless/headTables/TableHeadSells";
import StyleTableRow from "../../styles/styleTableRow";
import { Link } from "react-router-dom";
import {
  changeRowsPerPage,
  customDate,
  getBrandAndModel,
  getProductBarCode,
  getProductInfoSells,
  getProductPriceInSells,
  getProductType,
} from "../../_utils/utils";
import SiteSelect from "../../components/shared/selects/SiteSelect";
import UsersBySiteSelect from "../../components/shared/selects/UsersBySiteSelect";
import CategorySelect from "../../components/shared/selects/CategorySelect";
import { createPDFReport } from "../../components/core/reports/PdfSellsReport";
import DetailProductModal from "../../components/core/modals/DetailProduct";
import { createTicketReport } from "../../components/core/reports/TicketSellsReport";
import { groupAccesoriesAndTotalSells } from "../../components/core/sells/utils_sells";

const useStyles = makeStyles((theme) => ({
  title: { color: "#1C2668", fontWeight: 600 },
  table: {
    minWidth: 700,
  },
  chip: styles.chip,
  chipSite: styles.storeChip,
  successfulChip: styles.successfullChip,
  secondaryChip: styles.secondaryChip,
  blueLight: styles.blueLight,
  header: styles.header,
  detailsLink: styles.detailsLink,
}));

const ContainerGlobalSells = ({ addAlert, detailAlert }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [totalSellsArray, setTotalSellsArray] = useState([]);
  const [startDate, setStartDate] = React.useState(
    moment().subtract(1, "days").startOf("day").format()
  );
  const [endDate, setEndDate] = React.useState(moment().endOf("day").format());
  const [queryParams, setqueryParams] = useState({});
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDetailModal, setOpenDetailModal] = React.useState(false);
  const [productIdTracking, setProductIdTracking] = React.useState("");

  const handleQuerySelected = (key, value) => {
    if (key === "siteId" && value === "none") {
      console.log("setear userId si existe ");
      const copyQueryParams = { ...queryParams };
      delete copyQueryParams.userId;
      copyQueryParams[key] = "";
      setqueryParams(copyQueryParams);
    } else
      setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  const handleStartChange = (date) =>
    setStartDate(moment(date).startOf("day").format());

  const handleEndChange = (date) =>
    setEndDate(moment(date).endOf("day").format());

  const searchProductByFilters = async () => {
    const utcStartDate = moment(startDate).utc().format();
    const utcEndDate = moment(endDate).utc().format();
    if (moment(endDate).isAfter(moment(startDate))) {
      //reset pagination to 0
      setPage(0);
      try {
        const body = {
          ...queryParams,
          startDate: utcStartDate,
          endDate: utcEndDate,
        };
        console.log("queryParams", body);
        const { data } = await SellService.getAllSellsWithParams(body);
        console.log("data from sell", data);
        if (data.length) {
          const groupAccesoriesByBarCode = groupAccesoriesAndTotalSells(data);
          setTotalSellsArray(groupAccesoriesByBarCode.salesArray);
        } else {
          const error = {
            noData: "No se encontraron ventas con los filtros seleccionados",
          };
          throw error;
        }
      } catch (error) {
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: error.noData ? "warning" : "error",
          message: error.noData
            ? error.noData
            : error.msgs || "Error recuperar productos",
        });
      }
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "La fecha de inicio es MAYOR a la fecha de fin",
      });
      return;
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleOpenModal = (e, id) => {
    e.preventDefault();
    setProductIdTracking(id);
    setOpenDetailModal(true);
  };

  const showProductType = (item) => {
    if (typeof item.payment_method?.name === "number") {
      return `${getProductType(item.product?.productTypeId)}   (${
        item.payment_method?.name
      })`;
    } else return getProductType(item.product?.productTypeId);
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography variant="h4" component="h4" className={classes.title}>
            Ventas globales
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Grid item>
              <DatePicker
                disableToolbar
                variant="inline"
                format="DD/MM/yyyy"
                margin="normal"
                autoOk
                disableFuture
                label="Fecha de inicio"
                placeholder="20/02/2021"
                value={startDate}
                onChange={handleStartChange}
              />
            </Grid>
            <Grid item>
              <DatePicker
                disableToolbar
                variant="inline"
                format="DD/MM/yyyy"
                margin="normal"
                autoOk
                placeholder="21/02/2021"
                disableFuture
                label="Fecha de fin"
                value={endDate}
                onChange={handleEndChange}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <Grid item>
            <CategorySelect
              category={handleQuerySelected}
              showNone
              showAll={true}
            />
          </Grid>
          <Grid item>
            <SiteSelect site={handleQuerySelected} removeStore showNone />
          </Grid>
          {queryParams.siteId && (
            <Grid item>
              <UsersBySiteSelect
                title="Vendedor"
                noneTitle="TODOS"
                showNone
                user={handleQuerySelected}
                siteSelected={queryParams.siteId}
              />
            </Grid>
          )}
          <Grid item>
            <Button
              className={classes.rightButton}
              variant="contained"
              disabled={!Object.keys(queryParams).length}
              onClick={searchProductByFilters}
              color="primary"
              endIcon={<SearchIcon color="secondary" />}
            >
              Filtrar
            </Button>
          </Grid>
        </>
      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
      >
        <Grid item>
          <Button
            className={classes.rightButton}
            disabled={!totalSellsArray.length}
            variant="contained"
            onClick={() =>
              createPDFReport(
                totalSellsArray,
                startDate,
                endDate,
                "globalSells"
              )
            }
            color="primary"
            endIcon={<PictureAsPdfIcon color="secondary" />}
          >
            Generar reporte en PDF
          </Button>
        </Grid>

        <Grid item>
          <Button
            className={classes.rightButton}
            disabled={!totalSellsArray.length}
            variant="contained"
            onClick={() =>
              createTicketReport(
                totalSellsArray,
                startDate,
                endDate,
                "globalSells"
              )
            }
            color="primary"
            endIcon={<ReceiptIcon color="secondary" />}
          >
            Generar reporte en ticket
          </Button>
        </Grid>
      </Grid>

      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          {totalSellsArray.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              <TableHeadSells
                globalSells
                showSite={queryParams.siteId === ""}
              />
              <TableBody>
                {totalSellsArray
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <StyleTableRow key={i} className={classes.row}>
                      {queryParams.siteId === "" && (
                        <StyledTableCell align="center">
                          <Chip
                            label={item.site.name}
                            className={classes.chipSite}
                          />
                        </StyledTableCell>
                      )}
                      <StyledTableCell align="center">
                        <Chip
                          label={showProductType(item)}
                          className={classes.chip}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {getBrandAndModel(item, false)}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ fontWeight: 700 }}
                      >
                        {getProductInfoSells(item)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {getProductBarCode(item)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Chip
                          label={
                            <NumberFormat
                              value={getProductPriceInSells(item)}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                            />
                          }
                          className={classes.successfulChip}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ fontWeight: 600 }}
                      >
                        {item.user?.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {customDate(item.createdAt)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {item.product.movile?.lote ||
                          item.product.chip?.lote ||
                          "N/A"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Link
                          to=""
                          className={classes.detailsLink}
                          onClick={(e) => handleOpenModal(e, item.product.id)}
                        >
                          <DetailsTwoToneIcon
                            fontSize="small"
                            style={{ paddingTop: 6, color: "green" }}
                          />
                          Ver detalles
                        </Link>
                      </StyledTableCell>
                    </StyleTableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.header}
            >
              Seleccionar las opciones de busqueda para obtener las ventas
            </Typography>
          )}
        </TableContainer>
        {totalSellsArray.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalSellsArray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
        )}
        {openDetailModal && (
          <DetailProductModal
            open={openDetailModal}
            onClose={() => setOpenDetailModal(false)}
            productId={productIdTracking}
            productSold
          />
        )}
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
};

export default connect(null, dispatch)(ContainerGlobalSells);
